import { render } from "./user-tabset.vue?vue&type=template&id=5c3103e6"
import script from "./user-tabset.vue?vue&type=script&lang=js"
export * from "./user-tabset.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__